import React, { useState, useEffect, useRef } from "react"
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../actions'
import axios from 'axios'
import Merchandise from './Merchandise'
import { COLORS } from '../../utilities/colours'
import { Input, Button, Card, Header, Form, Icon, Image, Popup, Container, FormGroup, FormField, Message, Divider, Grid, Segment, Radio } from "semantic-ui-react"

const ConsumerMLBB = () => {
    const [mlbb, setMlbb] = useState({})
    const [userID, setUserID] = useState('')
    const [serverID, setServerID] = useState('')
    const [userName, setUserName] = useState('')
    const [isLoadingVerify, setIsLoadingVerify] = useState(false)
    const [isUserVerified, setIsUserVerified] = useState(false)
    const [showInvalidUserMessage, setShowInvalidUserMessage] = useState(false)
    const [showOutOfStockMessage, setShowOutOfStockMessage] = useState(false)
    const [packageDisplayName, setPackageDisplayName] = useState('')
    const [packageSupplierName, setPackageSupplierName] = useState('')
    const [gameItems, setGameItems] = useState([])
    const [selectedItem, setSelectedItem] = useState(null)
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [confirmEmail, setConfirmEmail] = useState(false)
    const [paymentMethod, setPaymentMethod] = useState('')
    const [showReview, setShowReview] = useState(false)
    const [showReviewFormError, setShowReviewFormError] = useState(false)
    const [reviewFormErrorStr, setReviewFormErrorStr] = useState('')
    const [isLoadingPayment, setIsLoadingPayment] = useState(false)
    const [showPaymentError, setShowPaymentError] = useState(null)

    const firstNameRef = useRef(null)
    const dispatch = useDispatch()
    const games = useSelector(state => state.games)

    useEffect(() => {
        dispatch(actions.fetchGames('consumers'))
    }, [dispatch])

    useEffect(() => {
        if (!games) return
        for (const game of games) {
            if (game.supplierName === 'mlbb') {
                setMlbb(game)
                break
            }
        }
    }, [games])

    const isUserRestrictedFromMLBB = (restrictedMLBBUsers) => {
        if (!Array.isArray(restrictedMLBBUsers)) return false
        for (const restrictedUser of restrictedMLBBUsers) {
            if (restrictedUser.userID === userID && restrictedUser.serverID === serverID) {
                console.log('User is restricted from mlbb package.')
                return true
            }
        }
        return false
    }
    const isPackageOutOfStock = (names, pkgs) => {
        const obj = {}
        if (!Array.isArray(pkgs)) return obj
        for (const pkg of pkgs) {
            if (names.includes(pkg.supplierPackageName)) obj[pkg.supplierPackageName] = pkg.isOutOfStock
        }
        return obj
    }
    const getPackageName = (showWhichPackage, pkgs) => {
        for (const pkg of pkgs) {
            if (pkg.supplierPackageName === showWhichPackage) return pkg.name
        }
    }
    const getGameItems = (showWhichPackage, pkgs) => {
        for (const pkg of pkgs) {
            if (pkg.supplierPackageName === showWhichPackage) return pkg.gameItems
        }
    }
    const getMarkup = () => {
        for (const pkg of mlbb.packages) {
            if (pkg.supplierPackageName === packageSupplierName) return pkg.markupConsumer
        }
    }
    const getPrice = (cost, discounted, discountRate) => {
        const markup = (discounted) ? Number(getMarkup()) - Number(discountRate) : Number(getMarkup())
        return Number(cost) + (markup/100 * Number(cost))
    }

    const passedFormValidation = () => {
        if (name === '') {
            setShowReviewFormError(true)
            setReviewFormErrorStr('Please enter first name')
            return false
        } else if (phone === '') {
            setShowReviewFormError(true)
            setReviewFormErrorStr('Please enter phone number with country code')
            return false
        } else if (email === '') {
            setShowReviewFormError(true)
            setReviewFormErrorStr('Please enter email address')
            return false
        } else if (!isValidEmail(email)) {
            setShowReviewFormError(true)
            setReviewFormErrorStr('Please enter a valid email address')
            return false
        } else if (confirmEmail === '') {
            setShowReviewFormError(true)
            setReviewFormErrorStr('Please enter confirm email address')
            return false
        } else if (email !== confirmEmail) {
            setShowReviewFormError(true)
            setReviewFormErrorStr('Email addresses do not match')
            return false
        } else if (paymentMethod === '') {
            setShowReviewFormError(true)
            setReviewFormErrorStr('Please select payment method')
            return false
        }
        setShowReviewFormError(false)
        return true
    }

    // ----- Handler functions -----
    const handleChangeField = e => {
        const { name, value } = e.target
        if (name === 'userID') setUserID(value)
        if (name === 'serverID') setServerID(value)
        if (name === 'name') setName(value)
        if (name === 'phone') setPhone(value)
        if (name === 'email') setEmail(value)
        if (name === 'confirmEmail') setConfirmEmail(value)
    }
    const handleSelectedGameItem = item => {
        setSelectedItem(item)
    }
    const handleVerifyButtonClicked = async () => {
        if (userID === '' || serverID === '') return
        setIsLoadingVerify(true)
        try {
            const [gameResponse, restrictedUsersResponse, verifyResponse] = await Promise.all([
                axios.get('/api/resellers/game/' + mlbb._id).catch(err => {
                    alert('Fail update game data, please try again. Error: ' + err)
                    throw err 
                }),
                axios.get('/api/restricted_mlbb_users').catch(err => {
                    alert('Fail to get restricted users, please try again. Error: ' + err)
                    throw err
                }),
                axios.post(process.env.NODE_ENV === 'development' ? '/api/proxy/consumers/verify_id_mlbb' : '/api/consumers/verify_id/mlbb', { userid: userID, serverid: serverID }).catch(err => {
                    alert(`Failed to verify ID, please try again. Error: ${err}`)
                    throw err
                })
            ])
            const isRestrictedFromMLBBPackage = isUserRestrictedFromMLBB(restrictedUsersResponse.data)
            const pkgs = gameResponse.data.packages
            const { mlbb_global, mlbb_special, name1, name2, error1, error2, region } = verifyResponse.data
            const mlbb_globalIsValid = mlbb_global === 'valid'
            const mlbb_specialIsValid = mlbb_special === 'valid'
            const outOfStock = isPackageOutOfStock(['mlbb', 'mlbb_special', 'mlbb_global'], pkgs)
            const mlbbOutOfStock = outOfStock.mlbb ?? false
            const mlbbSpecialOutOfStock = outOfStock.mlbb_special ?? false
            const mlbbGlobalOutOfStock = outOfStock.mlbb_global ?? false

            var showWhichPackage = ''
            if (mlbb_globalIsValid && mlbb_special === 'valid' && !mlbbOutOfStock) { // again, user is not from SG, and not from Indo. we prioritise showing mlbb package since it's cheaper. so, show mlbb if not out of stock.
                if (region === 'philippines' || isRestrictedFromMLBBPackage) showWhichPackage = 'mlbb_special' // but we can't show mlbb if user is from philippines or myanmar, as they won't be able to top up. we will show them mlbb_special instead.
                else showWhichPackage = 'mlbb'
            } 
            else if (mlbb_globalIsValid && mlbb_specialIsValid && mlbbOutOfStock) showWhichPackage = 'mlbb_special' // if mlbb is out of stock, then no choice, we will show mlbb_special instead
            else if (mlbb_specialIsValid) showWhichPackage = 'mlbb_special'
            else if (mlbb_globalIsValid) showWhichPackage = 'mlbb_global' 
            
            setPackageSupplierName(showWhichPackage)
            setPackageDisplayName(getPackageName(showWhichPackage, pkgs))
            setGameItems(getGameItems(showWhichPackage, pkgs))
            setUserName(mlbb_globalIsValid ? name1 : name2)
            setIsUserVerified((mlbb_globalIsValid || mlbb_specialIsValid))

            // Set error messages: out of stock / invalid user
            if (mlbb_globalIsValid && mlbb_specialIsValid) { // user is not from SG, and not from Indo. 
                if (mlbbOutOfStock && mlbbSpecialOutOfStock) setShowOutOfStockMessage(true)
            }
            if (mlbb_globalIsValid && mlbbGlobalOutOfStock) setShowOutOfStockMessage(true)
            else if (mlbb_specialIsValid && mlbbSpecialOutOfStock) setShowOutOfStockMessage(true)
            else setShowOutOfStockMessage(false)

            if ((showWhichPackage === 'mlbb_global' && error1) || (showWhichPackage === 'mlbb_special' && error2)) {
                if (error1 === 'Game is under maintenance' || error2 === 'Game is under maintenance') {
                    setShowOutOfStockMessage(true)
                } else {
                    setShowInvalidUserMessage(true)
                }
            } else if (!mlbb_globalIsValid && !mlbb_specialIsValid) {
                setShowInvalidUserMessage(true)
            } else {
                setShowInvalidUserMessage(false)
            }
        } catch (err) {
            console.log('One or more requests failed:', err)
        } finally {
            setIsLoadingVerify(false)
        }
    }
    const handleProceed = () => {
        setShowReview(true)
        setTimeout(() => {
            if (firstNameRef.current) {
                firstNameRef.current.focus()
            }
            scrollToElement('scrollToHere')
        }, 500)
    }
    const handlePurchaseItem = async () => {
        if (!passedFormValidation()) return
        setIsLoadingPayment(true)
        setShowPaymentError(null)
        try {
            const amount = roundUp2DP(getPrice(selectedItem.cost, selectedItem.isDiscountedConsumer, selectedItem.discountRateConsumer))
            const itemName = selectedItem.nameConsumer.subheader === '' ? selectedItem.nameConsumer.header : selectedItem.nameConsumer.header + ' ' + selectedItem.nameConsumer.subheader
            const dict = { consumer: { name, email, phone }, game: packageSupplierName, userid: userID, serverid: serverID, denom: selectedItem.nameSupplier, userName, itemName, amount, cost: selectedItem.cost, package: packageDisplayName }
            const response = await axios.post('/api/payment/hitpay/mlbb', dict)
            const orderDetails = { ...dict, orderID: response.data.orderID, gameName: 'Mobile Legends' }
            localStorage.setItem('orderDetails', JSON.stringify(orderDetails))
            window.location.href = response.data.paymentUrl
        } catch (err) {
            console.error("Payment error:", err)
            setShowPaymentError('Failed to initiate payment, please try again.')
            setIsLoadingPayment(false)
            alert(`Payment failed: ${err.message}`)
        }
    }

    // ----- Render functions -----
    const renderForm = () => {
        return (
            <Form>
                <FormGroup widths='equal'>
                    <FormField required control={Input} label={{ children: 'User ID', style: { color: COLORS.PRIMARY_GOLD } }} name='userID' value={userID} placeholder='User ID' onChange={handleChangeField}/>
                    <FormField required control={Input} label={{ children: 'Server ID', style: { color: COLORS.PRIMARY_GOLD } }} name='serverID' value={serverID} placeholder='Server ID' onChange={handleChangeField}/>
                </FormGroup>
                {isUserVerified ? <h4>{userName} ✅</h4> : (
                    <p style={{ marginTop: 15, fontSize: "0.9em", color: COLORS.TEXT_DIM }}>
                        Find your User ID and Server ID in-game under your profile.
                        <Popup wide trigger={<Icon color="yellow" circular name="info" size="small" />} position="bottom left">
                            <Image src='https://s3.ap-southeast-1.amazonaws.com/emperor-game-credits/06747303-FDB9-4844-928D-BAFBEBE3E36D-14748-000002665A97A0F7.jpeg' />
                        </Popup>
                    </p>
                )}
                <Button loading={isLoadingVerify} style={{ marginTop: 15, backgroundColor: COLORS.PRIMARY_GOLD, color: 'black' }} onClick={handleVerifyButtonClicked}><Icon name='gem'/>Verify</Button>
                {showOutOfStockMessage ? (
                    <Message style={{ marginTop: 30, marginBottom: 30 }} negative header={'Items for ' + packageDisplayName + ' are currently Out of Stock / Under Maintenance.'} content='Please try again later.'/>
                ) : null}
                {showInvalidUserMessage ? (
                    <Message style={{ marginTop: 20 }} negative header='Invalid user' content='Please check and try again.'/>
                ) : null}
            </Form>
        )
    }
    const renderItems = () => {
        if (!mlbb) return null
        if (isUserVerified && !showOutOfStockMessage) {
            return (
                <div>
                    <Divider style={{ marginTop: 30 }}/>
                    <h4>Eligible for {packageDisplayName}:</h4>
                    <Button size="large" loading={isLoadingPayment} style={{ marginTop: 20, background: selectedItem ? COLORS.PRIMARY_GOLD : COLORS.TEXT_DIM, color: COLORS.BACKGROUND, transition: "background 0.3s ease" }} disabled={!selectedItem || showReview} 
                        onClick={handleProceed}><Icon name="cart" /> Proceed to Payment</Button>
                    <Merchandise userName={userName} savedDict={{ gameItems: gameItems }} markup={getMarkup()} selectedItem={handleSelectedGameItem}/>
                    <Button size="large" loading={isLoadingPayment} style={{ marginTop: 60, background: selectedItem ? COLORS.PRIMARY_GOLD : COLORS.TEXT_DIM, color: COLORS.BACKGROUND, transition: "background 0.3s ease" }} disabled={!selectedItem || showReview} 
                        onClick={handleProceed}><Icon name="cart" /> Proceed to Payment</Button>
                </div>
            )
        }
        return null
    }
    const renderReview = () => {
        if (!mlbb || !showReview) return null
        const price = roundUp2DP(getPrice(selectedItem.cost, selectedItem.isDiscountedConsumer, selectedItem.discountRateConsumer))
        return (
            <div>
                <Divider id='scrollToHere' style={{ marginTop: 50, marginBottom: 30 }} />
                <Header as="h1" style={{ color: COLORS.PRIMARY_GOLD }}>Review Your Order</Header>
                <Grid style={{ marginTop: 20 }} stackable>
                    <Grid.Row>
                        <Grid.Column style={{ paddingLeft: 0 }} width={8}>
                            <Segment style={{ backgroundColor: COLORS.BACKGROUND }}>
                                <Header as="h2" style={{ color: COLORS.PRIMARY_GOLD }}>Billing Details</Header>
                                <Form style={{ marginTop: 30 }}>
                                    <Form.Field required>
                                        <label style={{ color: COLORS.TEXT_WHITE }}>First Name</label>
                                        <Input ref={firstNameRef} name='name' value={name} placeholder="First Name" onChange={handleChangeField}/>
                                    </Form.Field>
                                    <Form.Field required>
                                        <label style={{ color: COLORS.TEXT_WHITE }}>Phone</label>
                                        <Input name='phone' value={phone} placeholder="Phone" onChange={handleChangeField}/>
                                    </Form.Field>
                                    <Form.Field required>
                                        <label style={{ color: COLORS.TEXT_WHITE }}>Email Address</label>
                                        <Input name='email' value={email} placeholder="Email Address" onChange={handleChangeField}/>
                                    </Form.Field>
                                    <Form.Field required>
                                        <label style={{ color: COLORS.TEXT_WHITE }}>Confirm Email Address</label>
                                        <Input name='confirmEmail' value={confirmEmail} placeholder="Confirm Email Address" onChange={handleChangeField}/>
                                    </Form.Field>
                                    {showReviewFormError ? (
                                        <Message style={{ marginTop: 20 }} negative header={reviewFormErrorStr}/>
                                    ) : null}
                                </Form>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Header as="h2" style={{ color: COLORS.PRIMARY_GOLD }}>Your Order</Header>
                            <Card fluid style={{ marginTop: 38, padding: 4, paddingTop: 8, backgroundColor: COLORS.BACKGROUND }}>
                                <Card.Content>
                                    <Card.Header style={{ color: COLORS.PRIMARY_GOLD, marginBottom: 15 }}>Mobile Legends Bang Bang</Card.Header>
                                    <Card.Description style={{ color: COLORS.TEXT_WHITE }}>
                                        <p><strong>User Name:</strong> {userName}</p>
                                        <p><strong>User ID:</strong> {userID}</p>
                                        <p><strong>Server ID:</strong> {serverID}</p>
                                        <p><strong>Selected Item:</strong> {selectedItem.nameConsumer.header + ' ' + selectedItem.nameConsumer.subheader}</p>
                                        <p><strong>Price:</strong> ${price}</p>
                                        <Divider />
                                        <p><strong>Subtotal:</strong> ${price}</p>
                                        <p><strong>Tax:</strong> $0.00</p>
                                        <p><strong>Total:</strong> ${price}</p>
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                            <p style={{ color: COLORS.PRIMARY_GOLD, cursor: 'pointer' }}>
                                Have a coupon? <span style={{ textDecoration: 'underline' }}>Click to enter your coupon code</span>
                            </p>
                            <Form style={{ marginTop: 30 }}>
                                <Form.Field>
                                    <h3 style={{ color: COLORS.PRIMARY_GOLD, marginBottom: 15 }}>Payment Method</h3>
                                    <Radio style={{ color: COLORS.TEXT_WHITE }} label={{ children: "PayNow / GrabPay / ShopeePay Later / Atome", style: { color: COLORS.TEXT_WHITE } }} checked={paymentMethod === 'paynow'} onChange={() => setPaymentMethod('paynow')}/>
                                </Form.Field>
                                <Message info header='Please note' content='Screenshot QR code and upload to the bank to make payment. Do NOT re-use the same QR code.'/>
                                <Form.Field>
                                    <Radio style={{ color: COLORS.TEXT_WHITE }} label={{ children: "Manual Payment", style: { color: COLORS.TEXT_WHITE } }} checked={paymentMethod === 'manual'} onChange={() => setPaymentMethod('manual')}/>
                                </Form.Field>
                                <Button loading={isLoadingPayment} disabled={isLoadingPayment} style={{ marginTop: 15, backgroundColor: COLORS.PRIMARY_GOLD, color: 'black' }} size='large' onClick={handlePurchaseItem}>
                                    <Icon name='cart'/>Complete Payment
                                </Button>
                                {showPaymentError ? (
                                    <Message style={{ marginTop: 20 }} negative header='Payment Error' content={showPaymentError}/>
                                ) : null}
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
    return (
        <Container>
            <Image style={{ marginTop: 30, marginBottom: 50, width: '33%' }} centered src='/mobile-legends.png'/>
            {renderForm()}
            {renderItems()}
            {renderReview()}
        </Container>
    )
}

function roundUp2DP(num) {
    return Math.ceil(num * 100) / 100
}
    
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
}

function scrollToElement(elementId) {
    const element = document.getElementById(elementId)
    if (element) {
        element.style.scrollMarginTop = '5rem'
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}

export default ConsumerMLBB